import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import BranchInvoice from "../pages/BranchInvoice/BranchInvoiceList";
import CreateBranchInvoice from "../pages/BranchInvoice/CreateBranchInvoice";
import EditBranchInvoice from "../pages/BranchInvoice/EditBranchInvoice";
import BranchInvoicePreview from "../pages/BranchInvoice/BranchInvoicePreview";
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import CargoBranchInvoicePreview from "../pages/BranchInvoice/CargoBranchInvoicePreview";
import BranchFileUpload from "../pages/BranchInvoice/BranchFileUpload";
export const queryClient = new QueryClient();

const BranchInvoiceRouter = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path={"/"} element={<BranchInvoice />} />
          <Route
            path={"/create"}
            element={
              <AccessControl
                children={<CreateBranchInvoice />}
                allowedPermissions={["can_create_branch_invoice"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route path={"/edit/:id"} element={<EditBranchInvoice />} />
          <Route path={"/preview/:id"} element={<BranchInvoicePreview />} />
          <Route
            path={"/cargo-preview/:id"}
            element={<CargoBranchInvoicePreview />}
          />
          <Route path={"/documents/:id"} element={<BranchFileUpload />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default BranchInvoiceRouter;
